<script>
import {ArrowUpIcon,ArrowRightIcon} from 'vue-feather-icons';
import Navbar from "@/components/navbar";
import Layout from "@/layouts/main";
import appConfig from "@/app.config";
import axios from 'axios';

export default {
  components: {
    Layout,
    Navbar,
    ArrowUpIcon,
    ArrowRightIcon
  },
  data() {
    return {
      appConfig: appConfig,
      login: {
        idx: 0,
        level: 0,
        nick: "",
        isLogin: false,
      },
      region_list: [
        {"region": "전체", "cnt": 0}, 
        {"region": "대구", "cnt": 0}, 
        {"region": "부산", "cnt": 0}, 
        {"region": "울산", "cnt": 0}, 
        {"region": "경북", "cnt": 0}, 
        {"region": "경남", "cnt": 0}, 
        {"region": "서울", "cnt": 0}, 
        {"region": "경기", "cnt": 0}, 
        {"region": "인천", "cnt": 0}, 
        {"region": "대전", "cnt": 0}, 
        {"region": "광주", "cnt": 0}, 
        {"region": "강원", "cnt": 0}, 
        {"region": "충북", "cnt": 0}, 
        {"region": "충남", "cnt": 0}, 
        {"region": "전북", "cnt": 0}, 
        {"region": "전남", "cnt": 0}, 
        {"region": "제주", "cnt": 0}, 
      ],
      selectedRegion: "전체",
      mapName: '',
      mapTel: '',
      map: null,
      geocoder: null,
      baseInfo: {},
      list: [],
      uploadingSpinner: false,
      fileSinput: null,
      addMapModalType: null,
      addMapData: {
        idx: 0,
        name: '',
        address: '',
        tel: '',
        url: '',
        logo: '',
        val1: null,
        val2: null,
      },
      uploadingLogo: '',
    }
  },
  computed: {
  },
  mounted() {
  },
  created() {
    this.first();
    this.getWebSiteInfoBase()
    this.getList();
  },
  metaInfo() {
    return {
      title: '전국 지원기관 | 대구여성인권센터',
      meta: [
        {
          name: 'description',
          content: '전국 각 지역의 지원기관 소개입니다. 대구여성인권센터와 함께하는 전국 지원기관을 확인하세요.'
        },
        {
          property: 'og:title',
          content: '지원기관 | 대구여성인권센터'
        },
        {
          property: 'og:description',
          content: '전국 각 지역의 지원기관 소개입니다. 대구여성인권센터와 함께하는 전국 지원기관을 확인하세요.'
        },
        {
          property: 'og:url',
          content: window.location.href
        },
        {
          name: 'twitter:title',
          content: '지원기관 | 대구여성인권센터'
        },
        {
          name: 'twitter:description',
          content: '전국 각 지역의 지원기관 소개입니다. 대구여성인권센터와 함께하는 전국 지원기관을 확인하세요.'
        }
      ]
    }
  },
  methods: {
    async ensureKakaoLoaded() {
      return new Promise((resolve) => {
        if (window.kakao && window.kakao.maps) {
          resolve();
        } else {
          const existing = document.querySelector('script[src*="//dapi.kakao.com/v2/maps/sdk.js"]');
          if (existing) {
            existing.addEventListener('load', () => {
              if (window.kakao && window.kakao.maps && kakao.maps.load) {
                kakao.maps.load(() => resolve());
              } else {
                resolve();
              }
            });
          } else {
            const script = document.createElement('script');
            script.src = "//dapi.kakao.com/v2/maps/sdk.js?appkey=7b0ef77a6f9e5464aca1d29ecc4f1bbd&libraries=services&autoload=false";
            script.addEventListener('load', () => {
              kakao.maps.load(() => resolve());
            });
            document.head.appendChild(script);
          }
        }
      });
    },
    // 처음에 실행되는 부분
    async first() {
      // 로그인 사용자 정보
      let getLocalStorage = JSON.parse(localStorage.getItem('user'))
      if (getLocalStorage) {
        this.login.idx = getLocalStorage.idx
        this.login.nick = getLocalStorage.nick
        this.login.level = getLocalStorage.level
        this.token = getLocalStorage.token
      }
    },
    initMap() {
      const container = document.getElementById('thisMap');
      if (!container) return;
      const options = {
        center: new kakao.maps.LatLng(35.8556931789011, 128.600466095176),
        level: 2,
      };
      const map = new kakao.maps.Map(container, options);
      const geocoder = new kakao.maps.services.Geocoder();
      geocoder.addressSearch(this.map, (result, status) => {
        if (status === kakao.maps.services.Status.OK) {
          const coords = new kakao.maps.LatLng(result[0].y, result[0].x);
          // 마커 생성 및 표시
          const marker = new kakao.maps.Marker({
            map: map,
            position: coords,
          });
          // 지도 중심을 해당 위치로 이동
          map.setCenter(coords);
        } else {
          // 주소 검색 실패 시 사용자에게 알림
          if (status === kakao.maps.services.Status.ZERO_RESULT) {
            this.$notify({ 
              type: 'warning', 
              duration: 3000, 
              title: '주소 검색 실패', 
              text: '입력된 주소를 찾을 수 없습니다. 주소를 확인해주세요.' 
            });
          } else if (status === kakao.maps.services.Status.ERROR) {
            this.$notify({ 
              type: 'error', 
              duration: 3000, 
              title: '지도 오류', 
              text: '지도 서비스에 일시적인 오류가 발생했습니다.' 
            });
          }
          // 지도 div에 오류 메시지 출력
          container.innerHTML = '<div class="text-bold text-center text-danger h-100 d-flex align-items-center justify-content-center">주소를 찾을 수 없습니다.</div>';
        }
      });
    },
    // 홈페이지 기본정보
    getWebSiteInfoBase() {
      this.baseInfo = this.$store.getters.getWebSiteInfoBase
    },
    // 지역별 리스트 가져오기
    async getList() {
      await axios({
        method: 'POST',
        url: appConfig.fastapi + '/maps/getList',
        data: {
          "region": this.selectedRegion,
        },
      })
      .then((response) => {
        // 리스트 가져오기
        if (response.data.list) {
          this.list = response.data.list
        }
        // 지역별 카운트 가져오기 (region이름, cnt 카운트)
        if (response.data.region_list) {
          // region 리스트 가져온거에 기존에 this.region_list에 해당하는 이름 있으면 cnt 카운트를 기존에 값에 입력해주자
          response.data.region_list.forEach((regionData) => {
            const foundRegion = this.region_list.find(item => item.region === regionData.region);
            if (foundRegion) {
              foundRegion.cnt = regionData.cnt;
            }
          });
        }
        if (response.data.message) {
          this.$notify({ type: 'success', duration:2000, 'title': '실패', text: response.data.message})
        }
      })
      .catch((error) => {
        console.log(error)
      })
      .finally(() => {
        // 스크롤바 처리부분 로딩
        //AOS.init()
      })
    },
    regionSelect(value) {
      this.selectedRegion = value;
      this.getList();
    },
    addMap(val1, val2) {
      this.addMapModalType = val1;
      // 모달 창 띄우기
      if (val1 == 'add') {
        this.addMapData.name = '';
        this.addMapData.address = '';
        this.addMapData.tel = '';
        this.addMapData.url = '';
        this.addMapData.logo = '';
        this.addMapData.region = '';
      } else if (val1 == 'edit') {
        const target = this.list.find(item => String(item.idx) === String(val2));
        if (!target) {
          console.warn('addMap: 대상 항목을 찾을 수 없습니다.', val2);
          return;
        }
        this.addMapData.idx = target.idx;
        this.addMapData.name = target.name;
        this.addMapData.address = target.address;
        this.addMapData.tel = target.tel;
        this.addMapData.url = target.url;
        this.addMapData.logo = target.logo;
        this.addMapData.region = target.region;
      }
      this.$bvModal.show('addMapModal');
    },
    async thisMap(name, address, tel) {
      this.mapName = name;
      this.map = address;
      this.mapTel = tel;
      // 모달 창 띄우기 후 컨테이너 렌더 완료 타이밍에 지도 초기화
      this.$bvModal.show('thisMapModal');
      this.$nextTick(async () => {
        await this.ensureKakaoLoaded();
        // 모달 애니메이션 완료까지 약간 대기
        setTimeout(() => {
          this.initMap();
        }, 50);
      });
    },
    dragover(event) {
      event.preventDefault();
      if (!event.currentTarget.classList.contains('bg-success')) {
        event.currentTarget.classList.remove('bg-light');
        event.currentTarget.classList.add('bg-success');
      }
    },
    dragleave(event) {
      event.currentTarget.classList.add('bg-light');
      event.currentTarget.classList.remove('bg-success');
    },
    drop(event) {
      event.preventDefault();
      this.$refs.fileSinput.files = event.dataTransfer.files;
      //this.handleFileUpload();
      event.currentTarget.classList.add('bg-light');
      event.currentTarget.classList.remove('bg-success');
    },
    handleFileUpload(val) { // val =='add' or 'edit'
      const formData = new FormData();
      const file = this.$refs.fileSinput && this.$refs.fileSinput.files
        ? this.$refs.fileSinput.files[0]
        : null;

      if (val == 'add') {
        formData.append('exc_type', 'add');
        formData.append('exc_idx', 0); // 추가할 대상의 idx는 없으니 0으로 넣자
        if (file) {
          formData.append('files', file);  // 'files'와 FastAPI의 필드 이름이 일치해야 합니다.
        }
      } else if (val == 'edit') {
        formData.append('exc_type', 'edit');
        formData.append('exc_idx', this.addMapData.idx); // 수정할 대상의 idx
        if (file) {
          formData.append('files', file);  // 'files'와 FastAPI의 필드 이름이 일치해야 합니다.
        }
      }
      formData.append('region', this.addMapData.region);
      formData.append('name', this.addMapData.name);
      formData.append('address', this.addMapData.address);
      formData.append('tel', this.addMapData.tel);
      formData.append('url', this.addMapData.url);
      //spin 이미지 띄우자
      this.uploadingSpinner = true;
      axios({
        method: 'POST',
        url: appConfig.fastapi + '/maps/add_map_logo_upload',
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then((response) => {
        if (response.data.status == 'success') {
          this.$notify({ type: 'success', duration:2000, 'title': '성공', text: '완료되었습니다.'})
          this.getList();
          this.$bvModal.hide('addMapModal');
        } else {
          if (response.data.message) {
            this.$notify({ type: 'error', duration:2000, 'title': '실패', text: response.data.message})
          } else {
            this.$notify({ type: 'error', duration:2000, 'title': '실패', text: '관리자에게 문의해주세요'})
          }
        }
        // spin 이미지 닫자
        this.uploadingSpinner = false;
        // 업로드시킬 파일리스트는 초기화
        this.filelist = [];
        this.addMapData.logo = '';
        this.$refs.fileSinput.value=null;
        this.uploadingLogo = '';
      })
      .catch((error) => {
        console.log(error)
      })
      .finally(() => {
        // 스핀 이미지 닫자
        this.uploadingSpinner = false;
      })
    },
    // 삭제하기
    deleteMap(val) {
      // 정말 삭제할것인지 묻는 창
      const result = window.confirm("이 지원기관을 정말 삭제하시겠어요?");
      if (result) {
        this.sendDeleteMap(val);
      }
    },
    sendDeleteMap(val) {
      //spin 이미지 띄우자
      this.uploadingSpinner = true;
      axios({
        method: 'POST',
        url: appConfig.fastapi + '/maps/maps_delete',
        data: {
          "idx": val,
        },
        headers: {
          "access-token": this.token,
          "login-idx": this.login.idx,
        },
      })
      .then((response) => {
        if (response.data.status == 'success') {
          this.$notify({ type: 'success', duration:2000, 'title': '성공', text: "삭제되었습니다."})
          this.getList();
          this.$bvModal.hide('addMapModal');
        } else {
          if (response.data.message) {
            this.$notify({ type: 'error', duration:2000, 'title': '실패', text: response.data.message})
          } else {
            this.$notify({ type: 'error', duration:2000, 'title': '실패', text: '관리자에게 문의해주세요'})
          }
        }
        // spin 이미지 닫자
        this.uploadingSpinner = false;
      })
    },
    addMapSave(val) {
      // 항목 다 채웠는지 확인
      if (this.addMapData.region === '') {
        this.$notify({ type: 'error', duration:2000, 'title': '실패', text: '지역을 선택해주세요'})
        return;
      } else if (this.addMapData.name === '') {
        this.$notify({ type: 'error', duration:2000, 'title': '실패', text: '이름을 입력해주세요'})
        return;
      } else if (this.addMapData.address === '') {
        this.$notify({ type: 'error', duration:2000, 'title': '실패', text: '주소를 입력해주세요'})
        return;
      } else if (this.addMapData.tel === '') {
        this.$notify({ type: 'error', duration:2000, 'title': '실패', text: '전화번호를 입력해주세요'})
        return;
      } else if (this.addMapData.url === '') {
        this.$notify({ type: 'error', duration:2000, 'title': '실패', text: '홈페이지 URL을 입력해주세요'})
        return;
      } else {
        this.addMapData.logo = '';
        this.handleFileUpload(val)
      }
    },
    uploadingLogoConvert(event) {
      this.uploadingLogo = URL.createObjectURL(event.target.files[0])
    },
    // 경로 붙여주자
    convertLogo(val) {
      if (val) {
        return appConfig.fileserver+"/mapThum/"+val;
      } else {
        return appConfig.url + '/images/_decen/logo/logo_old.png';
      }
    },
    moveLink(val) {
      window.open(val, '_blank');
    },
    makeCall(val) {
      const tel = String(val || '').trim();
      if (!tel) return;
      // 간단한 모바일 기기 판별
      const ua = navigator.userAgent || '';
      const isMobile = /Android|iPhone|iPad|iPod|Windows Phone|webOS|BlackBerry/i.test(ua);
      if (isMobile) {
        // 모바일: 전화 앱 열기
        window.location.href = `tel:${tel}`;
      }
    },
  },
}
</script>

<template>
  <Layout>
    <!-- 지도열기 모달 창 -->
    <b-modal id="thisMapModal" title="지도열기" hide-footer>
      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-1">
          <div class="card">
            <div v-if="mapName !=='' && mapName !== null" class="">
              <div class="text-bold text-center">{{ mapName }}</div>
            </div>
            <div v-if="map !=='' && map !== null" class="">
              <div class="text-bold text-center">{{ map }}</div>
            </div>
            <div v-if="mapTel !=='' && mapTel !== null" class="">
              <div class="text-bold text-center">{{ mapTel }}</div>
            </div>
          </div>
        </div>
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-1">
          <div class="card">
            <div class="map map-height-two map-gray">
              <div id="thisMap" style="width:100%;height:500px"></div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- 추가하기 모달 창 -->
    <b-modal id="addMapModal" :title="addMapModalType == 'add' ? '지원기관 추가하기' : '수정'" hide-footer>
      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-1">
          <label for="addMapData.region" class="p-0 col-12">지역</label>
          <select id="addMapData.region" class="form-control" v-model="addMapData.region">
            <option selected value="대구">대구</option>
            <option value="부산">부산</option>
            <option value="울산">울산</option>
            <option value="경북">경북</option>
            <option value="경남">경남</option>
            <option value="서울">서울</option>
            <option value="경기">경기</option>
            <option value="인천">인천</option>
            <option value="대전">대전</option>
            <option value="광주">광주</option>
            <option value="강원">강원</option>
            <option value="충북">충북</option>
            <option value="충남">충남</option>
            <option value="전북">전북</option>
            <option value="전남">전남</option>
            <option value="제주">제주</option>
          </select>
        </div>
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-1">
          <label for="addMapData.name" class="p-0 col-12 mb-1 col-12">이름</label>
          <input id="addMapData.name" type="text" class="form-control" placeholder="이름" v-model="addMapData.name">
        </div>
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-1">
          <label for="addMapData.address" class="p-0 mt-2 mb-1 col-12">주소</label>
          <input id="addMapData.address" type="text" class="form-control" placeholder="주소" v-model="addMapData.address">
        </div>
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-1">
          <label for="addMapData.tel" class="p-0 mt-2 mb-1 col-12">전화번호</label>
          <input id="addMapData.tel" type="tel" class="form-control" placeholder="전화번호" v-model="addMapData.tel">
        </div>
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-1">
          <label for="addMapData.url" class="p-0 mt-2 mb-1 col-12">홈페이지 URL</label>
          <input id="addMapData.url" type="text" class="form-control" placeholder="홈페이지 URL" v-model="addMapData.url">
        </div>
        <div v-if="addMapData.logo" class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mb-1">
          <label for="addMapData.logo" class="p-0 mt-2 mb-1 col-12">기존 로고이미지</label>
          <div id="uploadingLogo" class="mb-2">
            <img :src="convertLogo(addMapData.logo)" class="img-fluid rounded" alt="" style="width: 100px; height: 100px;">
          </div>
        </div>
        <div v-if="uploadingLogo" class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mb-1">
          <label for="uploadingLogo" class="p-0 mt-2 mb-1 col-12">새 로고이미지</label>
          <div id="uploadingLogo" class="mb-2">
            <img :src="uploadingLogo" class="img-fluid rounded" alt="" style="width: 100px; height: 100px;">
          </div>
        </div>
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-1">
          <label for="FieldfileS" class="p-0 mt-2 mb-2 col-12">
            <div class="ed-clickable text-center bg-light" @dragover="dragover" @dragleave="dragleave" @drop="drop">
              <div class="mt-4" v-if="uploadingSpinner === true">
                <b-spinner class="display-5 text-success" label="Loading"></b-spinner>
                <h6 class="text-info">잠시만 기다려주세요...</h6>
              </div>
              <div class="" v-if="uploadingSpinner === false">
                <i class="display-5 text-primary mdi mdi-file-upload-outline"></i>
                <h6 class="">
                  로고이미지 클릭 or 끌어서넣기<br>
                  <small class="text-muted">jpg, jpeg, png 파일만 업로드 가능</small>
                </h6>
              </div>
            </div>
          </label>
          <input type="file" name="fields[FieldfileS]" id="FieldfileS" class="w-px h-px overflow-hidden" 
          ref="fileSinput" accept=".jpg,.jpeg,.png,.gif" @change="uploadingLogoConvert"/>
        </div>
        <div v-if="addMapModalType == 'add'" class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-2">
          <b-button class="btn btn-square btn-sm btn-block btn-soft-primary" @click="addMapSave('add')">저장하기</b-button>
        </div>
        <div v-else class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-2">
          <div class="row">
            <div class="col-xl-8 col-lg-8 col-md-8 col-sm-12">
              <b-button class="btn btn-square btn-sm btn-block btn-soft-primary" @click="addMapSave('edit')">수정하기</b-button>
            </div>
            <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12">
              <b-button class="btn btn-square btn-sm btn-block btn-soft-danger" @click="deleteMap(addMapData.idx)">삭제</b-button>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- 네비게이션 글자 하얗게는 :nav-light="true" -->
    <Navbar :nav-light="true" />

    <section class="bg-half-2 navwave d-table w-100">
      <div class="animation-effect-8"><i class="mdi mdi-cloud-outline effect-icon-1 text-primary"></i></div>
      <div class="animation-effect-9"><i class="mdi mdi-rocket effect-icon-1 text-light"></i></div>
      <div class="bread-overlay-2 opacity-5"></div>
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-12 text-center">
            <div class="page-next-level">
              <div class="title text-white title-dark">
                <h3>전국 지원기관</h3>
                <h4>각 지역의 지원기관 소개입니다</h4>
              </div>
              <div class="page-next">
                <nav aria-label="breadcrumb" class="d-inline-block">
                  <ul class="breadcrumb bg-white rounded shadow mb-0">
                    <li class="breadcrumb-item">
                      <router-link to="/">홈</router-link>
                    </li>
                    <li class="breadcrumb-item "><a href="#">상담</a></li>
                    <li class="breadcrumb-item active" aria-current="page">전국 지원기관</li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 둥글게 처리 -->
    
    <div class="position-relative">
      <div class="shape overflow-hidden text-white">
        <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
        </svg>
      </div>
    </div>

    <section class="section">
      <div class="container">
        <div class="row">

          <!-- 지역 영역 -->
          <div class="col-lg-3 col-md-12 col-sm-12 mb-4">
            <div class="card sidebar sticky-bar p-2">
              <div class="">
                <h5 class="widget-title">지역선택</h5>
                <ul v-if="region_list" class="list-unstyled mb-4 row">
                  <li v-for="(item, key) in region_list" :key="key" v-if="item.cnt > 0" class="col-4 cursor-pointer mb-1 ">
                    <div class="accounts border text-center rounded p-1" 
                        :class="selectedRegion === item.region ? 'bg-primary text-white' : 'unselected-menu text-secondary'" 
                        @click="regionSelect(item.region)">
                      <span class="title font-size-12 text-bold">
                        <span class="badge badge-pill font-size-10">{{ item.region }}</span>
                        <span class="badge badge-pill font-size-10" 
                          :class="selectedRegion === item.region ? 'badge-light' : 'badge-light'">{{ item.cnt }}</span>
                      </span>
                    </div>
                  </li>
                </ul>
                <!-- 관리자의 경우 추가하기 버튼 나오게 -->
                <div v-if="login.level >= 98" class="">
                  <b-button @click="addMap('add', null)" class="btn btn-square btn-sm btn-block btn-soft-primary">지원기관 추가하기</b-button>
                </div>
              </div>
            </div>
          </div>

          <!-- 리스트 -->
          <div class="col-lg-9 col-md-12 col-sm-12 mb-4">
            <div class="row">
              <div v-for="item in list" :key="item.idx" class="col-lg-6 col-12 mb-4 pb-2">
                <div class="card job-box rounded border overflow-hidden">
                  <div class="border-bottom">
                    <div class="gallery-noimg text-center">
                      <img :src="convertLogo(item.logo)" class="img-fluid" loading="lazy" />
                      <!-- 흐릿하게 하려면 class에 job-overlay 넣으면됨 -->
                      <div class="job-overlay bg-white"></div>
                    </div>
                    <ul class="list-unstyled head mb-0">
                      <!--<li class="badge badge-soft-secondary badge-pill">{{ item.region }}</li>-->
                      <li class="bg-soft-secondary badge-pill h5 text-bold">{{ item.region }}</li>
                    </ul>
                  </div>
                  <div class="card-body content position-relative">
                    <div class="company-detail text-center mb-3">
                      <h5 class="mb-0">
                        <div class="text-secondary company-name">{{ item.name }}</div>
                      </h5>
                    </div>
                    <ul class="job-facts list-unstyled">
                      <li class="text-muted font-size-13 mb-1">
                        <i class="mdi mdi-map-marker mr-1"></i>{{ item.address }}
                      </li>
                      <!-- 모바일에서 전화 걸 수 있게 -->
                      <li @click="makeCall(item.tel)" class="text-muted font-size-13 mb-1 cursor-pointer">
                        <i class="mdi mdi-phone mr-1"></i>{{ item.tel }}
                      </li>
                      <li @click="moveLink(item.url)" class="text-muted font-size-13 mb-1 cursor-pointer">
                        <i class="mdi mdi-home mr-1"></i>{{ item.url }}
                      </li>
                    </ul>
                    <ul class="list-unstyled mb-0 text-center">
                      <li class="list-inline-item">
                        <b-button class="btn btn-sm btn-soft-blue btn-block font-size-13" @click="moveLink(item.url)">
                          <i class="mdi mdi-home"></i>홈페이지
                        </b-button>
                      </li>
                      <li class="list-inline-item mt-2 ml-2">
                        <b-button @click="thisMap(item.name, item.address, item.tel)" class="btn btn-sm btn-soft-warning btn-block font-size-13">
                          <i class="mdi mdi-map-marker"></i>지도열기
                        </b-button>
                      </li>
                    </ul>
                  </div>
                  <div v-if="login.level >= 98" class="p-1">
                    <b-button @click="addMap('edit', item.idx)" class="btn btn-sm btn-square btn-block btn-soft-primary">편집하기</b-button>
                  </div>
                </div>
              </div>
              <!-- 결과 없다면 -->
              <div v-if="list.length === 0" class="col-12 text-center">
                <h4 class="text-muted">결과가 없습니다.</h4>
              </div>

            </div>
          </div>


        </div>
      </div>
    </section>
  </Layout>
</template>
